import dayjs from 'dayjs';

export const DateDisplayFormat = 'MM/dd/yyyy';

export const isoStringToDate = (str: string): Date => {
    return dayjs(str).toDate();
};

export const toDate = (val: string | Date): Date | null => {
    if (!val) return null;
    if (typeof val === typeof Date) return val as Date;
    return dayjs(val).toDate();
};

export const toIsoDateString = (val: Date | null): string | null => {
    if (!val) return null;
    return dayjs(val).format('YYYY-MM-DD');
};
